import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import SectionCard from "./SectionCard";
import useScrolledToBottom from "./useScrolledToBottom";

const isTermsVerified = (termsAgreedDateTime) =>
  termsAgreedDateTime != null && String(termsAgreedDateTime).trim() !== "";

const formatSignedDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const Step6Terms = ({ formData, groupId, setFieldValue }) => {
  const verified = isTermsVerified(formData.termsAgreedDateTime);
  const isAgreed = Boolean(formData.termsAccepted);
  const skipScrollGate = verified || isAgreed || groupId?.isAdmin;
  const { scrollRef, scrolledToBottom } = useScrolledToBottom(true);
  const canAgree = skipScrollGate || scrolledToBottom;

  return (
    <>
      <SectionCard title="VENDOR TERMS AND CONDITIONS">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              ref={scrollRef}
              sx={{
                maxHeight: 400,
                overflowY: "auto",
                p: 1,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
              }}
            >
    

    <Typography sx={{ fontSize: "14px", mb: 1 }}>
      These Vendor Terms and Conditions shall apply to all vendors engaged by the Company.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      1. Compliance with Purchase Orders
    </Typography>

        <Typography sx={{ fontSize: "14px", mb: 1 }}>
      All prices, specifications, scope of work, delivery schedules, and service terms as mentioned in the Purchase Order (PO) shall be final. No deviation shall be accepted unless expressly approved in writing by the Company.
    </Typography>

        <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      2. Invoicing Requirements:
    </Typography>
    <Typography sx={{ fontSize: "14px", ml: 2 }}>•	The vendor shall submit one tax invoice per PO. Multiple PO numbers against a single invoice are not permitted..</Typography>
    <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
      • Invoices must strictly match the PO details.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      3. Mandatory Dispatch / Service Documents
    </Typography>
    <Typography sx={{ fontSize: "14px", ml: 2 }}>The vendor shall submit the following documents, as applicable:</Typography>

    <Typography sx={{ fontSize: "14px", ml: 2 }}>• Tax Invoice</Typography>
    <Typography sx={{ fontSize: "14px", ml: 2 }}>• Packing List</Typography>
    <Typography sx={{ fontSize: "14px", ml: 2 }}>• Statutory Forms (if applicable)</Typography>
    <Typography sx={{ fontSize: "14px", ml: 2 }}>• E-Way Bill</Typography>
    <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Quality Inspection / Test Report
    </Typography>
       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
      • Any additional documents required under applicable laws or country-specific regulations
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      4. Delivery & Service Location
    </Typography>

    <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
     Goods and/or services shall be delivered or performed only at the delivery address mentioned in the Purchase Order (PO). The vendor must quote the Company’s GST number and PO reference on all invoices. The vendor shall obtain proper material delivery acknowledgment with official seal and signature from the concerned department. The vendor must also ensure collection and compliance with Modenik  final quality inspection status after dispatch and delivery.
    </Typography>


    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      5. Jurisdiction
    </Typography>

       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
     All disputes shall be subject to the exclusive jurisdiction of courts located in <Typography sx={{ fontSize: "14px",fontWeight: "bold" }}>Bangalore, Karnataka, India.</Typography>
         </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      6. Quantity Tolerance
    </Typography>

      <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
    A quantity variance of ±5% is acceptable at PO value. Any excess quantity beyond this limit shall be rejected and returned at the vendor’s cost.
         </Typography>
         
    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      7. Rejection & Penalties
    </Typography>

        <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Goods not conforming to quality specifications shall be rejected.
    </Typography>
       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
      • Any losses or penalties incurred due to vendor non-compliance shall be recoverable from the vendor.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      8. Freight & Transportation
    </Typography>

         <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
          Unless otherwise mentioned, transportation shall be arranged as per agreed commercial terms. Freight-on-pay basis shall be intimated in advance.
         </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      9. Inspection
    </Typography>

       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
          The Company reserves the right to inspect goods at the vendor’s premises, during transit, or at the Company warehouse (physically or virtually). Acceptance at any stage does not waive the Company’s right to reject goods if non-compliance is found later.
         </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      10. Transit Insurance 
    </Typography>

     <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
          Transit insurance shall be arranged by the vendor unless explicitly agreed otherwise. The Company shall not be responsible for loss or damage during transit.
         </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      11. Demurrage & Delay
    </Typography>

      <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
          Any demurrage, detention, or additional charges arising due to vendor delay or non-compliance shall be borne by the vendor and may be deducted from payments.
         </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      12. Rejected Material Handling
    </Typography>

      <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Rejected goods must be removed by the vendor at their own cost within timelines specified by the Company.
    </Typography>
       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
      • Disposal, if required, shall be the vendor’s responsibility.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      13. Termination
    </Typography>

      <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
          The Company reserves the right to terminate the vendor relationship with immediate effect in case of breach of terms, quality failures, or non-compliance with statutory requirements.
         </Typography>

   <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      14. Tax & GST Compliance
    </Typography>

         <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Vendors shall comply with all GST regulations.
    </Typography>
       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
      • GST amounts shall be released only after the same is reflected correctly in the Company’s GST returns (GSTR-2A / 2B).
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      15. Invoice Management System (IMS) Compliance
    </Typography>
      <Typography sx={{ fontSize: "14px", ml: 2 }}>
       The vendor shall comply with the <Typography sx={{ fontSize: "14px",fontWeight: "bold" }}>Invoice Management System (IMS)</Typography> requirements as prescribed under the GST laws of India and as implemented by the Goods and Services Tax Network (GSTN) from time to time.
    </Typography>

       <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Vendors must ensure timely, accurate, and correct reporting of invoices in <Typography sx={{ fontSize: "14px",fontWeight: "bold" }}>GSTR-1 / relevant returns.</Typography>
    </Typography>
             <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Any amendments, cancellations, or corrections to invoices shall be done strictly within the timelines prescribed under GST law.
    </Typography>
             <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Vendors shall ensure that invoices/ Debit Note/ Credit note are properly accepted, rejected, or amended in the IMS framework after proper communication with Modenik lifestyle Pvt ltd.,, to enabling correct reflection in the Company’s <Typography sx={{ fontSize: "14px",fontWeight: "bold" }}>GSTR 2B.</Typography>
    </Typography>
       <Typography sx={{ fontSize: "14px", ml: 2 }}>
      • Any loss of Input Tax Credit (ITC), interest, penalty, or compliance risk arising due to vendor’s non compliance with IMS or GST provisions shall be fully recoverable from the vendor.
    </Typography>

        <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
      Non compliance with IMS requirements shall be treated as a material breach and may lead to withholding of payments, suspension, or cancellation of the vendor code.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      16. Vendor Invoice GST return status:
    </Typography>

          <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
     In ledger invoice line-item wise GST return status also update monthly once.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      17. Vendor balance confirmation:
    </Typography>

        <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
     Depending on transaction volume, vendors shall provide confirmation on a yearly, half yearly, or quarterly basis. Vendor ledger confirmation must be completed item wise within the prescribed timelines. In case any invoice is not reflected in the vendor Ledger, the vendor shall follow up with the concerned Modenik order placing representative without delay to be confirm by vendor.
    </Typography>

   <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      18. COBC:
    </Typography>

       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
     As per company norms COBC rules to be followed & acknowledged yearly once.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      19. Job worker & FOB Agreement: 
    </Typography>

      <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
    Job work & FOB vendor Agreement must be sign-off yearly once.
    </Typography>

    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
      20. Acceptance of Terms.
    </Typography>

       <Typography sx={{ fontSize: "14px", ml: 2, mb: 1 }}>
    By accepting a PO or doing business with the Company, the vendor confirms acceptance of these Vendor Terms and Conditions. 
    </Typography>

  </Box>
          </Grid>

          {!skipScrollGate && !scrolledToBottom && (
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "14px", color: "warning.main" }}>
                Please scroll to the bottom of the terms and conditions before proceeding.
              </Typography>
            </Grid>
          )}

          {verified && (
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "15px", color: "success.main" }}>
                You have accepted the terms and conditions.
              </Typography>
            </Grid>
          )}
        </Grid>
      </SectionCard>

      {!isAgreed && !groupId?.isAdmin && (
        <Button
          variant="contained"
          color="primary"
          type="button"
          disabled={!canAgree}
          onClick={() => setFieldValue("termsAccepted", true)}
          sx={{ mr: 1, mt: 2 }}
        >
          I AGREE
        </Button>
      )}

      {!formData.termsAgreedDateTime?.length > 0 && isAgreed && !groupId?.isAdmin && (
        <Typography sx={{ color: "success.main", mt: 2 }}>
          Terms accepted for this step. You can proceed to next step.
        </Typography>
      )}

    {groupId?.isAdmin && (
  formData.termsAgreedDateTime?.length > 0 ? (
    <Typography sx={{ color: "success.main", mt:2, ml: 2 }}>
      Digitally signed on: {formatSignedDate(formData.termsAgreedDateTime)}
    </Typography>
  ) : (
    <Typography sx={{ color: "error.main",mt:2, ml: 2 }}>
      Agreement not signed yet
    </Typography>
  )
)}
    </>
  );
};

export default Step6Terms;
